// TrademarkRegistration.jsx
import { React, useState, useRef } from "react";
import ContactPopup from "../ContactPopup";
import { Helmet } from "react-helmet";
// import "./ServicePage.css";
import "../ImportExport/ServicePages.css";
// TrademarkRegistration.jsx

const TrademarkRegistration = () => {
  
 const [openPopup, setOpenPopup] = useState(false);

    const contactRef = useRef(null);

    const scrollToContact = () => {
        contactRef.current?.scrollIntoView({ behavior: "smooth" });
    }
  return (
    <div className="service-page">

      <Helmet>
        <title>
          Trademark Registration Service in India | Brand & Logo Protection
        </title>

        <meta
          name="description"
          content="Protect your brand name, logo, slogan, and business identity with Trademark Registration in India. Fast and hassle-free trademark filing services."
        />

        <meta
          name="keywords"
          content="Trademark Registration, Logo Registration, Brand Name Registration, Trademark Filing India, TM Registration"
        />
      </Helmet>

      {/* HERO */}
      <section className="service-hero">
        <h1>Trademark Registration Service (™ / ®)</h1>

        <p>
          Protect Your Brand Name, Logo & Business Identity Legally
        </p>
         <button className="hero-btn" onClick={scrollToContact}>
                        Get Started Today
                    </button>
      </section>

      {/* OVERVIEW */}
      <section className="service-section">
        <h2>Overview</h2>

        <div className="card">
          <p>
            Trademark Registration helps protect your business identity,
            including your brand name, logo, slogan, tagline, symbol, or unique
            business mark from unauthorized use.
          </p>

          <p>
            A registered trademark gives you exclusive legal rights to use your
            brand and helps build trust, recognition, and business value.
          </p>
        </div>
      </section>

      {/* WHAT IT PROTECTS */}
      <section className="service-section">
        <h2>What Does Trademark Protect?</h2>

        <div className="service-grid-box">
          <div className="card">Brand Name</div>
          <div className="card">Business Logo</div>
          <div className="card">Tagline / Slogan</div>
          <div className="card">Product Name</div>
          <div className="card">Website / App Brand</div>
          <div className="card">Business Identity</div>
        </div>
      </section>

      {/* EXAMPLES */}
      <section className="service-section">
        <h2>Examples of Trademarks</h2>

        <div className="card">
          <ul>
            <li>Company Name</li>
            <li>Business Logo</li>
            <li>Brand Tagline</li>
            <li>Unique Product Names</li>
            <li>Symbols & Labels</li>
            <li>Packaging Brand Identity</li>
          </ul>
        </div>
      </section>

      {/* BENEFITS */}
      <section className="service-section">
        <h2>Benefits of Trademark Registration</h2>

        <div className="service-grid-box">
          <div className="card">
            ✔ Exclusive legal ownership of brand
          </div>

          <div className="card">
            ✔ Prevents brand copying & misuse
          </div>

          <div className="card">
            ✔ Builds trust & credibility
          </div>

          <div className="card">
            ✔ Creates strong brand identity
          </div>

          <div className="card">
            ✔ Valuable business asset
          </div>

          <div className="card">
            ✔ Legal protection across India
          </div>
        </div>
      </section>

      {/* VALIDITY */}
      <section className="service-section">
        <h2>Trademark Validity</h2>

        <div className="card">
          <p>
            Trademark registration is valid for <strong>10 years</strong> and
            can be renewed repeatedly for lifetime protection of your brand.
          </p>
        </div>
      </section>

      {/* WHO SHOULD APPLY */}
      <section className="service-section">
        <h2>Who Should Apply for Trademark?</h2>

        <div className="service-grid-box">
          <div className="card">Startups</div>
          <div className="card">Business Owners</div>
          <div className="card">Manufacturers</div>
          <div className="card">Service Providers</div>
          <div className="card">E-commerce Sellers</div>
          <div className="card">Professionals & Agencies</div>
        </div>
      </section>

      {/* DOCUMENTS */}
      <section className="service-section">
        <h2>Documents Required</h2>

        <div className="service-grid-box">
          <div className="card">PAN Card</div>
          <div className="card">Aadhaar Card</div>
          <div className="card">Logo (if available)</div>
          <div className="card">Business Registration Proof</div>
          <div className="card">Address Proof</div>
          <div className="card">Power of Attorney</div>
        </div>
      </section>

      {/* PROCESS */}
      <section className="service-section">
        <h2>Trademark Registration Process</h2>

        <div className="service-grid-box">
          <div className="card">
            Trademark Search
          </div>

          <div className="card">
            Class Selection
          </div>

          <div className="card">
            Application Filing
          </div>

          <div className="card">
            Government Examination
          </div>

          <div className="card">
            Objection Handling (if any)
          </div>

          <div className="card">
            Registration Certificate
          </div>
        </div>
      </section>

      {/* OUR SERVICES */}
      <section className="service-section">
        <h2>Our Trademark Services Include</h2>

        <div className="card">
          <ul>
            <li>Trademark availability search</li>
            <li>Class selection guidance</li>
            <li>Application drafting & filing</li>
            <li>Trademark objection support</li>
            <li>Trademark renewal assistance</li>
            <li>Complete end-to-end support</li>
          </ul>
        </div>
      </section>

      {/* WHY CHOOSE US */}
      <section className="service-section">
        <h2>Why Choose Us?</h2>

        <div className="card">
          <ul>
            <li>✔ Expert IPR professionals</li>
            <li>✔ Fast & accurate filing</li>
            <li>✔ Affordable pricing</li>
            <li>✔ Complete legal support</li>
            <li>✔ Dedicated customer assistance</li>
          </ul>
        </div>
      </section>

      {/* CTA */}
      {/* <section className="service-cta">
        <h2>Secure Your Brand Identity Today</h2>

        <p>
          Protect your business name and logo with professional trademark
          registration services.
        </p>

        <button>Apply for Trademark</button>
      </section> */}
          <div className="cta" ref={contactRef}>
              <h2>Secure Your Brand Identity Today</h2>
 <p>
          Protect your business name and logo with professional trademark
          registration services.
        </p>
              <div className="cta-buttons">
                <button onClick={() => setOpenPopup(true)}>Apply for Trademark  </button>
                <ContactPopup
                  isOpen={openPopup}
                  onClose={() => setOpenPopup(false)}
                />
      
                <button className="outline" onClick={() => window.location.href = "tel:9218103915"} >Free Consultation</button>
              </div>
            </div>


    </div>
  );
};

export default TrademarkRegistration;